<div class="combo-box" #comboBox>

  <label class="combo-label" *ngIf="label">{{ label }}<span class="text-danger fw-bold" *ngIf="required">*</span></label>

  <div class="input-wrapper">
    <input
  type="text"
  [value]="selectedValue" [ngClass]="{'disabled-color': isDisabled}" [disabled]="isDisabled"
  (input)="onInputChange($any($event.target).value)"
  (focus)="showDropdown = true" [readonly]="!isAllowInputyping"
  [placeholder]="placeholder" (keypress)="checkOnlyNumber($event)"
/>
     <span
      class="arrow" [ngClass]="{'cursor-default': isDisabled}"
      [class.disabled]="isDisabled"
      (click)="!isDisabled && toggleDropdown()">

      <i class="fa-solid fa-chevron-down"></i>

    </span>
  </div>

  <ul *ngIf="showDropdown" class="dropdown">
    <li *ngFor="let item of items" (click)="selectItem(item)">
      {{ item }}
    </li>
  </ul>

</div>